import { createStyles, makeStyles } from '@hawkins/styles';
export var ROOT_PADDING_X_KEY = 'space2';
export function navigationMenuItemStyles(theme) {
    var _a, _b, _c;
    var hawkins = theme.hawkins, hawkinsUtils = theme.hawkinsUtils, hawkinsVariables = theme.hawkinsVariables;
    var backgroundColorActive = hawkins.state.backgroundColorSelected;
    var gap = hawkinsVariables.spacingValues.space0;
    var iconDim = hawkinsVariables.sizings.size1;
    var minHeight = hawkinsVariables.sizingValues.size2 * 1.5;
    var rootActiveStyling = {
        backgroundColor: backgroundColorActive,
        '& $caret, & $icon': { color: hawkins.icon.fillRegular },
        '& $caretTransparent, & $iconTransparent': { color: hawkins.persistent.iconFillWhiteRegular },
        '& $label': { color: hawkins.textColor.textColorRegular },
        '& $labelTransparent': { color: hawkins.persistent.textColorWhiteRegular },
    };
    return createStyles({
        /** Class name of the `Accordion`. */
        accordion: {
            // HACK(style): CSS override specificity.
            '&.Hawkins-Accordion': {
                backgroundColor: 'transparent',
                borderBottomWidth: 0,
            },
        },
        /** Class name of the `Accordion` when the component is active. */
        accordionActive: {
            '& $accordionSummary': {
                // HACK(style): CSS override specificity.
                '&.Hawkins-AccordionSummary': (_a = {
                        backgroundColor: backgroundColorActive
                    },
                    _a[hawkinsUtils.getHoveredElementSelector('&')] = {
                        backgroundColor: hawkins.state.backgroundColorSelectedHover,
                    },
                    _a['& $rootActive, & $root.active'] = { backgroundColor: 'transparent' },
                    _a),
            },
            '& $accordionSummaryToggleIcon': { color: hawkins.icon.fillRegular },
        },
        /** Class name of the `AccordionDetails`. */
        accordionDetails: {
            // HACK(style): CSS override specificity.
            '&.Hawkins-AccordionDetails': {
                borderBottomWidth: 0,
                padding: "".concat(hawkinsVariables.spacingValues.space0 / 2, "px 0"),
            },
        },
        /** Class name of the `AccordionSummary`. */
        accordionSummary: {
            // HACK(style): CSS override specificity.
            '&.Hawkins-AccordionSummary': {
                backgroundColor: 'transparent',
                borderBottomWidth: 0,
                borderRadius: hawkinsVariables.borderRadius.borderRadius0,
                minHeight: minHeight,
                padding: 0,
            },
        },
        /** Class name of the `AccordionSummary` content. */
        accordionSummaryContent: {},
        /** Class name of the `AccordionSummary` when the `Accordion` is not disabled. */
        accordionSummaryEnabled: (_b = {},
            _b[hawkinsUtils.getHoveredElementSelector('&')] = {
                backgroundColor: hawkins.state.backgroundColorHover,
                '& $rootHoverable': { backgroundColor: 'transparent' },
            },
            _b),
        /** Class name of the `AccordionSummary` toggle icon. */
        accordionSummaryToggleIcon: {
            color: hawkins.icon.fillLight,
        },
        /** Class name of the `AccordionSummary` toggle icon container. */
        accordionSummaryToggleIconContainer: {
            marginRight: hawkinsVariables.spacings.space2,
        },
        /** Class name of the caret icon. */
        caret: {
            color: hawkins.icon.fillLight,
            marginLeft: 'auto',
        },
        /** Class name of the caret when in a transparent navigation component. */
        caretTransparent: {
            color: hawkins.persistent.iconFillWhiteLight,
        },
        /** Class name of the component icon. */
        icon: {},
        /** Class name of the icon when in a transparent navigation component. */
        iconTransparent: {},
        /** Class name of the element containing the icon. */
        iconContainer: {
            '& > $icon': {
                '&$iconTransparent': {
                    color: hawkins.persistent.iconFillWhiteLight,
                },
                color: hawkins.icon.fillLight,
                height: iconDim,
                width: iconDim,
            },
            alignItems: 'center',
            display: 'flex',
        },
        /** Class name of the icon container when in a vertical navigation component. */
        iconContainerVertical: {
            marginRight: hawkinsVariables.spacingValues.space4 - gap,
            paddingLeft: hawkinsVariables.spacings.space1,
            '&:last-child': { marginRight: 0 },
        },
        /** Class name of the label. */
        label: {},
        /** Class name of the element containing the label. */
        labelContainer: {
            // Allow the label to be truncatable.
            overflow: 'hidden',
        },
        /** Class name of the label when in a transparent navigation component. */
        labelTransparent: {
            color: hawkins.persistent.textColorWhiteLight,
        },
        /** Class name of the nested menu element. */
        nestedMenu: {
            margin: "0 ".concat(hawkins.focus.borderWidthRegular),
            padding: hawkinsVariables.spacingValues.space0 / 2,
        },
        /** Class name of the root element. */
        root: {
            alignItems: 'center',
            borderRadius: hawkinsVariables.borderRadius.borderRadius0,
            display: 'flex',
            gap: gap,
            minHeight: minHeight,
            padding: "".concat(hawkinsVariables.spacings.space1, " ").concat(hawkinsVariables.spacings[ROOT_PADDING_X_KEY]),
            // In case the root element is a `<button />`.
            backgroundColor: 'transparent',
            borderWidth: 0,
            textAlign: 'start',
            // In case the root element is an `<a />`.
            textDecoration: 'none',
            '&.active': rootActiveStyling,
        },
        /** Class name of the root element when the component is active. */
        rootActive: rootActiveStyling,
        /**
         * Class name of the root element when the component is clickable
         * (i.e., has an `onClick` callback OR is a link OR is a `Menu` trigger) and is not disabled.
         */
        rootClickable: {
            cursor: 'pointer',
        },
        /** Class name of the root element when the component is disabled. */
        rootDisabled: {
            cursor: 'not-allowed',
            '& $caret, & $icon': { color: hawkins.icon.fillXlight },
            '& $caretTransparent, & $iconTransparent': { color: hawkins.persistent.iconFillWhiteXlight },
            '& $labelTransparent': { color: hawkins.persistent.textColorWhiteXlight },
            '& $subtitleTransparent': { color: hawkins.persistent.textColorWhiteXlight },
        },
        /**
         * Class name of the root element when the component is hoverable (i.e., is clickable OR has a nested menu)
         * and not disabled.
         */
        rootHoverable: (_c = {},
            _c[hawkinsUtils.getHoveredElementSelector('&')] = { backgroundColor: hawkins.state.backgroundColorHover },
            _c[[
                hawkinsUtils.getHoveredElementSelector('&$rootActive'),
                hawkinsUtils.getHoveredElementSelector('&.active'),
            ].join(', ')] = { backgroundColor: hawkins.state.backgroundColorSelectedHover },
            _c),
        /** Class name of the root element when in a vertical navigation component. */
        rootVertical: {
            // Make the root element take up 100% width in case it's wrapped inside an `<li />`.
            width: '100%',
        },
        /** Class name of the subtitle. */
        subtitle: {},
        /** Class name of the subtitle when in a transparent navigation component. */
        subtitleTransparent: {
            color: hawkins.persistent.textColorWhiteLight,
        },
    });
}
export var useNavigationMenuItemStyles = makeStyles(navigationMenuItemStyles, { name: 'Hawkins-NavigationMenuItem' });
